import { FGInput, FGInputField, FGButton } from '@fg/design-system';
import { useState } from 'react';
import { getCookie } from '../services/cookieHelper';
import { callPiwik } from '../services/Login';

type Props = {
  ssoAPICall: Function;
  identitySamlBaseUrl: string;
  identityCognitoBaseUrl: string;
  attemptedUrl: string;
  initialUrl: string;
  clientId: string;
};
export const SSOView = ({
  ssoAPICall,
  identitySamlBaseUrl,
  identityCognitoBaseUrl,
  attemptedUrl,
  initialUrl,
  clientId,
}: Props) => {
  const id = 'sing-in-view';
  const rememberOrgId = getCookie('organizationNameKey') || '';

  const [organizationId, setOrganizationId] = useState(rememberOrgId);
  const handleChange = (e: any) => {
    setOrganizationId(e.target.value);
  };
  const callSSO = (e: any) => {
    e.preventDefault();
    ssoAPICall(organizationId).then((response) => {
      if (response && response.id) {
        if (response.cognitoAllowed) {
          window.location.replace(
            `${identityCognitoBaseUrl}/v1/cognito/authorize?orgId=${response.id}&clientId=${encodeURIComponent(
              clientId
            )}&initialUrl=${encodeURIComponent(initialUrl ? initialUrl.replace(/&amp;/g, '&') : '')}`
          );
        } else {
          window.location.replace(
            `${identitySamlBaseUrl}/saml/login?orgId=${response.id}&clientId=${encodeURIComponent(
              clientId
            )}&attemptedUrl=${encodeURIComponent(attemptedUrl)}`
          );
        }
        callPiwik(['trackEvent', 'Login-SSO', 'Click', 'Successful_Log_In']);
      }
    });
    return false;
  };

  const handleKeypress = (e) => {
    if (e.charCode === 13 && organizationId) {
      callSSO(e);
    }
  };
  return (
    <div className="fg-mg--t10 fg-fxd--c tab-panel-content">
      <FGInputField id={`${id}-sso-field`} label="Organization ID">
        <FGInput
          onChange={handleChange}
          onKeyPress={handleKeypress}
          name="organizationId"
          value={organizationId}
          size="l"
          id={`${id}-sso-field`}
        />
      </FGInputField>
      <div className="fg-pd--y6" style={{ display: 'inline-grid' }}>
        <FGButton disabled={!organizationId} onClick={callSSO} size="xl">
          Continue
        </FGButton>
      </div>
    </div>
  );
};
